<template>
  <v-fade-transition>
    <v-snackbar v-model="loading">
      <v-progress-circular indeterminate color="primary" size="20" class="mr-4" />
      <span v-if="message" class="ml-2">{{ message }}</span>
    </v-snackbar>
  </v-fade-transition>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLoaderStore } from '@/store/loader';
const loaderStore = useLoaderStore();
const loading = computed(() => loaderStore.loading);
const message = computed(() => loaderStore.message);
</script>
